<template>
    <div class="navigation" v-if="currentStep && completed">
        <nav>
            <ul>
                <li>
                    <button class="nav-step"
                            :disabled="!completed.step_1"
                            @click="changeStep(1)"
                            :class="{'active' : currentStep == 1, 'done' : completed.step_1 }">
                        <span class="circle">
                            <span class="number">1</span>
                            <svg class="checkmark"><use xlink:href="#checkmark"></use></svg>
                        </span>
                        <span class="text">Intro<span class="not-mobile">duction</span></span>
                    </button>
                </li>
                <li>
                    <button class="nav-step"
                            :disabled="!completed.step_2"
                            @click="changeStep(2)"
                            :class="{'active' : currentStep == 2, 'done' : completed.step_2 }">
                        <span class="circle">
                            <span class="number">2</span>
                            <svg class="checkmark"><use xlink:href="#checkmark"></use></svg>
                        </span>
                        <span class="text">Membership</span>
                    </button>
                </li>
                <li>
                    <button class="nav-step"
                            :disabled="!completed.step_3"
                            @click="changeStep(3)"
                            :class="{'active' : currentStep == 3, 'done' : completed.step_3 }">
                        <span class="circle">
                            <span class="number">3</span>
                            <svg class="checkmark"><use xlink:href="#checkmark"></use></svg>
                        </span>
                        <span class="text">Your <br>Details</span>
                    </button>
                </li>
                <li>
                    <button class="nav-step"
                            :disabled="!completed.step_4"
                            @click="changeStep(4)"
                            :class="{'active' : currentStep == 4, 'done' : completed.step_4 }">
                        <span class="circle">
                            <span class="number">4</span>
                            <svg class="checkmark"><use xlink:href="#checkmark"></use></svg>
                        </span>
                        <span class="text"><span class="not-mobile">Your </span>Travel <br>Style</span>
                    </button>
                </li>
                <li>
                    <button class="nav-step"
                            :disabled="!completed.step_5"
                            @click="changeStep(5)"
                            :class="{'active' : currentStep == 5, 'done' : completed.step_5 }">
                        <span class="circle">
                            <span class="number">5</span>
                            <svg class="checkmark"><use xlink:href="#checkmark"></use></svg>
                        </span>
                        <span class="text">Housekeeping</span>
                    </button>
                </li>
            </ul>
        </nav>
    </div>

    <!--div class="navigation">
        <nav>
            <ul>
                <li>
                    <button class="nav-step active">
                        <input type="hidden" name="step" value="Intro">
                        <span class="circle">
                            <span class="number">1.</span>
                            <svg class="checkmark"><use xlink:href="#checkmark"></use></svg>
                        </span>
                        <span class="text">Intro<span class="not-mobile">duction</span>
                    </button>
                </li>
                <li>
                    <button class="nav-step">
                        <input type="hidden" name="step" value="Membership">
                        <span class="circle">
                            <span class="number">2.</span>
                            <svg class="checkmark"><use xlink:href="#checkmark"></use></svg>
                        </span>
                        <span class="text">Membership</span>
                    </button>
                </li>
                <li>
                    <button class="nav-step">
                        <input type="hidden" name="step" value="Your Details">
                        <span class="circle">
                            <span class="number">3.</span>
                            <svg class="checkmark"><use xlink:href="#checkmark"></use></svg>
                        </span>
                        <span class="text">Your <br>Details</span>
                    </button>
                </li>
                <li>
                    <button class="nav-step">
                        <input type="hidden" name="step" value="Your Travel Style">
                        <span class="circle">
                            <span class="number">4.</span>
                            <svg class="checkmark"><use xlink:href="#checkmark"></use></svg>
                        </span>
                        <span class="text"><span class="not-mobile">Your </span>Travel <br>Style</span>
                    </button>
                </li>

                <?php /*
                <li>
                <button class="nav-step">
                <span class="circle">
                    <span class="number">5.</span>
                    <svg class="checkmark"><use xlink:href="#checkmark"></use></svg>
                </span>
                    <span class="text"><span >Interests</span>
                </button>
                </li>
                */ ?>
                <li>
                    <button class="nav-step">
                        <input type="hidden" name="step" value="Housekeeping">
                        <span class="circle">
                            <span class="number">5.</span>
                            <svg class="checkmark"><use xlink:href="#checkmark"></use></svg>
                        </span>
                        <span class="text">Housekeeping</span>
                    </button>
                </li>
            </ul>
        </nav>
    </div-->

</template>
<script>
export default {

    data(){
        return {
            currentStep: null,
            completed: null,
        }
    },

    created(){
        eventBus.$on('step-change', data => {
            this.completed = data.completed
            this.currentStep = data.step
        })
    },

    methods:{
        changeStep(step){
            eventBus.$emit('change-nav-step', step)
        }
    }
}
</script>
